import {WixSdk} from '@wix/js-sdk-wrapper';
import {StatisticParams} from '@wix/music-player';
import {EventEmitter} from 'events';
import {BI_ERRORS} from '../logging/errors';
import {logError} from '../logging/logging';
import {subscribeToEmitter} from './subscribe-to-emitter';

export function logToActivities(statisticsEventsEmitter: EventEmitter) {
  const events = {
    trackPlayStart: {
      endpoint: WixSdk.Activities.Type.TRACK_PLAY, // 'music/track-play-start',
      params: getTrackParams,
    },
    trackSkipped: {
      endpoint: WixSdk.Activities.Type.TRACK_SKIP, // 'music/track-skipped',
      params: getTrackParams,
    },
    trackPlayCompleted: {
      endpoint: WixSdk.Activities.Type.TRACK_PLAYED, // 'music/track-play-complete',
      params: getTrackParams,
    },
    trackShareClicked: {
      endpoint: WixSdk.Activities.Type.TRACK_SHARE, // 'music/track-share',
      params: (args: StatisticParams) => ({
        ...getTrackParams(args),
        sharedTo: args.network && args.network.toUpperCase(),
      }),
    },
    albumPlayCompleted: {
      endpoint: WixSdk.Activities.Type.ALBUM_PLAYED, // 'music/album-play-complete',
      params: getAlbumParams,
    },
    albumShareClicked: {
      endpoint: WixSdk.Activities.Type.ALBUM_SHARE, // 'music/album-share',
      params: (args: StatisticParams) => ({
        ...getAlbumParams(args),
        sharedTo: args.network && args.network.toUpperCase(),
      }),
    },
  };

  subscribeToEmitter(statisticsEventsEmitter, events, (eventName, eventDescription, eventArgs: any) => {
    const viewMode = WixSdk.Utils.getViewMode();
    if (viewMode === 'editor' || viewMode === 'preview') {
      return;
    }

    const data = {
      type: eventDescription.endpoint,
      info: eventDescription.params(eventArgs),
      details: null,
      contactUpdate: null,
    };

    try {
      WixSdk.Activities.postActivity(data).catch((reason: Error | unknown) => {
        logError(BI_ERRORS.widget.statistic.activity.send, {reason});
      });
    } catch (reason) {
      logError(BI_ERRORS.widget.statistic.activity.send, {reason});
    }
  });

  function getAlbumParams({album}: StatisticParams) {
    return {
      album: {id: album.id, name: album.name},
      artist: {name: album.artistName},
    };
  }

  function getTrackParams(params: StatisticParams) {
    return {
      ...getAlbumParams(params),
      track: {id: params.track.id, name: params.track.name},
    };
  }
}
